import "./EditPartnerUser.html";
import "./EditPartnerUser.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditPartnerUserComponentController from "./EditPartnerUserComponentController";

export default class EditPartnerUserComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditPartnerUserComponentController;
        this.templateUrl = "/App/Components/PartnerUser/Details/EditPartnerUser/EditPartnerUser.html";
    }
}

module("mmManagePortal").component("irEditPartnerUser", new EditPartnerUserComponent());
